export default __webpack_public_path__ + "static/media/feature_image_1.54e87291.png";